<template>
    <sa-page-layout ref="SaplPostiLettoPianiView" :btnRouterBackVisible="true" :data="jsonData" :showModalLoading="showModalLoading" :pathResource="pathResource">
        <template slot="toolbar">
            <b-button class="float-sm-right" variant="outline-success btn-toolbar sa-margin-right" size="sm" @click="onClickAssociaPazienti">
                <b-icon icon="people-fill"></b-icon>
                Associa Paziente
            </b-button>
        </template>
        <template slot="table-body">
            <pazienti-progetti-view-component ref="PazientiProgettiViewComponent" :showModalLoading="showModalLoading" @errorRestCall="onError" @update="onUpdateJsonData" @beforeLoadData="onBeforeLoadData" @afterLoadData="onAfterLoadData"></pazienti-progetti-view-component>
        </template>
    </sa-page-layout>
</template>

<script>
import SaPageLayout from "../../../template/sa/components/layout/contents/SaPageLayout.vue";
import PazientiProgettiViewComponent from "../components/PazientiProgettiViewComponent.vue";
export default {
    components: { SaPageLayout, PazientiProgettiViewComponent },
    beforeMount() {
        let me = this;
        me.idPiano = me.$route.params.id;
    },
    mounted() {
        let me = this;
        me.loadData();
    },
    data() {
        return {
            showModalLoading: false,
            pathResource: "/pazientiprogetti",
            idPiano: null,
            jsonData: {},
        };
    },
    methods: {
        loadData() {
            let me = this;
            me.$refs.PazientiProgettiViewComponent.loadData();
        },

        onUpdateJsonData(data) {
            let me = this;
            me.jsonData = data;
        },
        onBeforeLoadData() {
            let me = this;
            me.showModalLoading = true;
        },
        onAfterLoadData() {
            let me = this;
            me.showModalLoading = false;
        },
        onError(errorData) {
            let me = this;
            me.$refs.PazientiProgettiViewComponent.showModalError(errorData);
        },
        onClickAssociaPazienti() {
            let me = this;
            me.$refs.PazientiProgettiViewComponent.associaPaziente();
        },
    },
};
</script>

<style></style>
